import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isAddProjectExternalLinkRequestFailure() {
      return getState().isFailure;
    },
    isAddProjectExternalLinkRequestPending() {
      return getState().isPending;
    },
    isAddProjectExternalLinkRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
